import { Injectable } from '@angular/core';
import { AdjustmentDto } from 'src/app/invoices/dto/adjustment.dto';
import { ApiService } from 'src/app/shared';
import { TransactionDto } from '../transaction/transaction.dto';

@Injectable({
  providedIn: 'root',
})
export class AdjustmentService {
  constructor(private _apiService: ApiService) {}

  createSimple(dto: AdjustmentDto): Promise<number> {
    return this._apiService.post('Adjustments/CreateSimple', dto, true);
  }

  getPostedTransactions(id: number): Promise<TransactionDto[]> {
    return this._apiService.get(`Adjustment/${id}/Transactions`);
  }
}
